// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoCategory\ApiCargoCategory.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';

// CargoCategoryData is the class that CargoCategory serializes to/from
export interface CargoCategoryData {
    Id : number;
    Url : string | null;
	
    Organization : OrganizationData | null;
    OrganizationId : number;
	
    Active : boolean;
    DisplayOrder : number;
    Name : string;
    UOM : string;
}

// CargoCategoryOptions is the class which may be passed to the CargoCategory constructor to define optional initial data values
export interface CargoCategoryOptions {
    Id : number;
    Url? : string | null;
	
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
	
    Active? : boolean;
    DisplayOrder? : number;
    Name? : string;
    UOM? : string;
}

export class CargoCategory {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
	
    public Active : DataSignal<boolean>;
    public DisplayOrder : DataSignal<number>;
    public Name : DataSignal<string>;
    public UOM : DataSignal<string>;

    constructor();
    constructor(data : CargoCategoryOptions);
    constructor(data: CargoCategoryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.UOM = jsonableObservable(S.value<string>(data && data.UOM !== undefined ? data.UOM : ''));
    }

    static key(obj : CargoCategory) {
        return obj.Id();
    }
    
    static dataKey(obj : CargoCategoryOptions) {
        return obj.Id;
    }

    static update(obj : CargoCategory, data : CargoCategoryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.UOM !== undefined) obj.UOM(data.UOM);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CargoCategory.ts